import type { ReactNode } from 'react';
import TopTextBlock from '@/components/TopTextBlock';

interface ResidencyShellProps {
  title: string;
  children: ReactNode;
  /** The white footer band always renders; leave unset for a screen with no
   *  way forward (e.g. `ResidencyBlocked`), which keeps the band empty. */
  footer?: ReactNode;
}

/**
 * The shared chrome for the residency gate's two screens: grey page, step
 * dashes + white title card, centered content, and a white footer band.
 * Local to this folder on purpose — it reproduces the layout the shared
 * `LayoutPageMobile`/`Row` components used to render for these two screens
 * only, not a general-purpose page shell.
 */
export default function ResidencyShell({
  title,
  children,
  footer,
}: ResidencyShellProps) {
  return (
    <div className="relative grid min-h-[100dvh] w-full grid-rows-[max-content_1fr_max-content] overflow-hidden bg-[#f5f5f5] pt-5">
      <div className="flex justify-center">
        {/* activeDashes={0}: the gate sits before question 1, so the bar
            must not claim progress that has not happened. */}
        <TopTextBlock title={title} activeDashes={0} />
      </div>

      <div className="flex items-center justify-center overflow-y-auto">
        {children}
      </div>

      <div className="flex w-full justify-center rounded-t-[4px] bg-white py-5">
        {footer}
      </div>
    </div>
  );
}
